import InfoIcon from "@mui/icons-material/InfoOutlined";
import type { SxProps, Theme } from "@mui/material";
import { IconButton, Popover, Typography } from "@mui/material";
import { useState } from "react";

interface Props {
  text: string;
  sx?: SxProps<Theme>;
}

const WidgetFootnoteButton = ({ text, sx }: Props) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement>();

  return (
    <>
      <IconButton aria-label="footnote" sx={sx} onClick={(e) => setAnchorEl(e.currentTarget)}>
        <InfoIcon />
      </IconButton>
      <Popover
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(undefined)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        slotProps={{ paper: { sx: { maxWidth: "20rem", p: 2 } } }}
      >
        <Typography variant="caption" color="textSecondary" sx={{ whiteSpace: "pre-wrap" }}>
          {text}
        </Typography>
      </Popover>
    </>
  );
};

export default WidgetFootnoteButton;
